import { render, staticRenderFns } from "./logs-tab.vue?vue&type=template&id=5a4a66cc"
import script from "./logs-tab.vue?vue&type=script&lang=js"
export * from "./logs-tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports